module.exports = "/_next/static/images/ourPartnersLogo13-41900a4a28165dab0603f97ac0244c4b.webp";